/* unplugin-vue-components disabled */import script from "./tab-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./tab-bar.vue?vue&type=script&setup=true&lang=js"

import "./tab-bar.vue?vue&type=style&index=0&id=cfab1bc0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfab1bc0"]])

export default __exports__